import { useMemo } from 'react';
import { useLanguageVariationsProvider } from '../providers/LanguageVariationsProvider';
import useAnalyticsPageId from './useAnalyticsPageId';
const useReportingContentIds = ({
  variationId,
  variationIds
}) => {
  const analyticsPageId = useAnalyticsPageId();
  const {
    allLangVariationContentIds,
    isCurrentlyViewingAllLangVariations
  } = useLanguageVariationsProvider();
  const processedContentId = variationId || analyticsPageId;
  const processedContentIds = isCurrentlyViewingAllLangVariations ? allLangVariationContentIds : variationIds;
  return useMemo(() => ({
    contentId: processedContentId,
    contentIds: processedContentIds
  }), [processedContentId, processedContentIds]);
};
export default useReportingContentIds;